import React, { Fragment, useEffect, useRef, useState } from 'react';
import { kpHistory, RouterActionEnum } from '../../../../../common/router/history';

import { TyLink, TyNavMenuMap } from '../../../../../types';
import Flyout from './flyout';
import MenuItem from './menu-item';
import MenuLinks from './Menu-links';
import QuickLink from '../../../../basic/quickLink';

interface NavMenuProps {
    menuBlocks?: any
}
export default function NavMenuBlocks({ menuBlocks }: NavMenuProps) {
    const [selectedMenu, setSelectedMenu] = useState('');
    const [selectedMenuParent, setSelectedMenuParent] = useState('');
    const [selectedMenuUrl, setSelectedMenuUrl] = useState('');
    const [menuindex, setindex] = useState(-1);
      const url = new URL(window.location.href);
    useEffect(() => {
        return kpHistory.listen(({ action }) => {
            if (action === RouterActionEnum.PUSH) setSelectedMenu('');
        });
    }, []);

    useEffect(() => {
        setSelectedMenuParent('');
        let selectedItem = '';
        {
            menuBlocks && Object.keys(menuBlocks).map((menu: string) => {
                menuBlocks[menu].map((item:any) => {
                    if(item.menu === true ){
                        item?.data?.map((subItem:any) => {
                            const pathName = window.location.pathname;
                            if (pathName.includes(subItem.href) && subItem.href != "/" && subItem.href != "/login") {
                                if (selectedItem == '') {
                                    setSelectedMenuParent(menu);
                                    selectedItem = menu;
                                }
                            }
                        })
                    }
                })
            })
        }
    });
    useEffect(() => {
        if (selectedMenuParent && url && url.href) {
            setSelectedMenuUrl((url.href.replace(/[\s\W]/g, '').toLowerCase()).
                includes(selectedMenuParent.replace(/[\s\W]/g, '').toLowerCase()) ? selectedMenuParent : '');
        }
    }, [url]);
    
    return (
        <div className="flex w-full items-center justify-center relative">
            <div
                className="flex flex-1 items-center justify-start relative"
                data-testid="selectToSetMenu"
            >
                <nav className="flex items-center justify-center lg:gap-sm xl:gap-md mt-4 py-sm" aria-label='Main Menu' data-testid="menuLinks" role='navigation'>

                    {menuBlocks && Object.keys(menuBlocks).map((key, index: any) => (
                        <Fragment key={key}>
                            {menuBlocks[key].map((item: any, li: any) => (
                                <Fragment key={li}>
                                    {item.menu === true && ( 
                                        <div className={`${selectedMenuUrl === (key) ? 'border-sky-200 border-b-4' : 'hover:border-b-2 hover:border-sky-200 border-b-2 border-transparent'} `}>
                                            <MenuItem 
                                                key={`hd-dt-nmi-${li}`}
                                                name={key}
                                                subNavMap={item?.data}
                                                selectedMenu={selectedMenu}
                                                selectedMenuParent={selectedMenuParent}
                                                index={menuindex} 
                                                handleClick={() => {
                                                    setSelectedMenu(key)
                                                    setindex(index)
                                                }}
                                                color={true}
                                            />
                                         </div>
                                    )}
                                    {item.menu === false && (
                                        <MenuLinks navLinks={[item.data]} />
                                    )}
                                </Fragment>
                            ))}
                        </Fragment>
                    ))}
                </nav>
            </div>
        </div>
    );
}
